import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Lesson_delete($id: ID!) {
    Lesson_delete(id: $id) {
      value
    }
  }
`;

const moduleDelete = async id =>
  // eslint-disable-next-line camelcase
  graphql(mutation, { id }).then(({ Lesson_delete }) => Lesson_delete);

export default moduleDelete;
